import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { PersistGate } from "redux-persist/integration/react";
import ReduxToastr from "react-redux-toastr";
import Router from "./Router";

class App extends Component {
  componentDidMount() {
    /* Set the scrollRestoration to manual to avoid browsers to restore the previous scroll
     * position when navigating through the app
     */
    if ("scrollRestoration" in window.history) {
      // Back off, browser, I got this...
      window.history.scrollRestoration = "manual";
    }

    window._axcb = window._axcb ? window._axcb : [];
    /* Handle Axeptio acceptance to prevent data to mismatch user preferences
     * as it needs to reload the page to save it
     */
    window._axcb.push(function (sdk) {
      sdk.on("close", function (choices) {
        window.location.reload();
      });
    });
  }

  render() {
    return (
      <Provider store={this.props.store}>
        <PersistGate persistor={this.props.persistor}>
          <Helmet defaultTitle="Murfy.fr" />
          <ConnectedRouter history={this.props.history}>
            <Router />
          </ConnectedRouter>
          <ReduxToastr
            timeOut={4000}
            newestOnTop
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
          />
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
